import { useState } from 'react';
import { Validation } from '@/models';
import useValidation from './useValidation';

const emptyPredicat = (value: string) => value === '';
const notEmptyPredicat = (value: string) => value !== '';

function useInputText(initialValue: string, validations: Validation[]) {
  const [value, setValue] = useState<string>(initialValue);
  const [isDirty, setIsDirty] = useState(false);

  const validationErrors = useValidation(value, validations);

  const onChange = (newValue: string) => {
    setValue(newValue);
    if (initialValue === newValue) {
      setIsDirty(false);
    }
  };

  const onBlur = () => {
    setIsDirty(true);
  };

  const onReset = () => {
    setIsDirty(false);
    setValue('');
  };

  const errorMessages = Object.values(validationErrors);

  return {
    value,
    isDirty,
    onChange,
    onBlur,
    onReset,
    isValid: errorMessages.every(emptyPredicat),
    errors: errorMessages.filter(notEmptyPredicat),
  };
}

export default useInputText;
